import { useRouter } from 'next/router';
import React, { ComponentType, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'redux/store';

export default function WithSession<T extends JSX.IntrinsicAttributes>(
  Component: ComponentType<T>,
): ComponentType<T> {
  const WrappedComponent = (props: T): ReactElement | null => {
    const sessionStatus = useSelector((state: Store) => state.auth.status);
    const router = useRouter();

    if (sessionStatus === 'to be determined') {
      return null;
    }

    if (sessionStatus === 'present') {
      return <Component {...props} />;
    }

    if (typeof window !== 'undefined') {
      router.push(
        `/login?next=${encodeURIComponent(router.asPath)}&required=true`,
      );
    }

    return null;
  };

  return WrappedComponent;
}
